export const shouldShowWebShare = () => {
    const title = 'Read The F*ing Directions';
    const url = window.location.href;

    return Boolean(navigator.canShare && navigator.canShare({ title, url }));
};

export const webShareUrl = () => {
    const title = 'Read The F*ing Directions';
    const url = window.location.href;

    if (navigator.share) {
        navigator.share({ title, url });
    }
};
